import { createSlice } from '@reduxjs/toolkit';

const numberOfRowsSlice = createSlice({
  name: 'numberOfRows',
  initialState: 8,
  reducers: {
    setNumberOfRows: (state, action) => {
      state = action.payload;
      return state;
    }
  },
});

export const { setNumberOfRows } = numberOfRowsSlice.actions;
export default numberOfRowsSlice.reducer;
